export const Label = ({ children, ...props }) => (
    <label className="block text-sm font-medium mb-1" {...props}>
      {children}
    </label>
  );
  
